// folderIcons.js
// The hand-drawn category icons that ship with the extension, offered here as
// ready-made folder pictures.
//
// They are the same seven files the repricer's category row uses
// (extension/images, drawn by hand for this app), copied into public/ so the
// web app can serve them the way the extension serves them through
// chrome.runtime.getURL. Copied rather than imported because the extension is a
// separate build with its own packaging — a bundler import across that boundary
// would tie one build to the other's directory layout.
//
// They sit above the item search in the picker on purpose: a folder called
// "Knives" wants the knife icon, and having to search the 40,000-item database
// for a picture of a category the app already drew would be the wrong default.
//
// Order matches the extension's CATEGORIES so the two lists read the same.

const DIR = '/folder-icons';

export const FOLDER_ICONS = [
  { id: 'knife',   label: 'Knives',        src: `${DIR}/knife.png` },
  { id: 'gloves',  label: 'Gloves',        src: `${DIR}/gloves.png` },
  { id: 'pistols', label: 'Pistols',       src: `${DIR}/pistols.png` },
  { id: 'smg',     label: 'SMGs',          src: `${DIR}/Smg.png` },
  { id: 'rifles',  label: 'Rifles',        src: `${DIR}/rifles.png` },
  { id: 'heavy',   label: 'Heavy',         src: `${DIR}/heavy.png` },
  { id: 'case',    label: 'Cases & Other', src: `${DIR}/case.png` },
];

/** The preset an image is, or null when it is an item picture or a URL. */
export function iconPreset(src) {
  if (!src) return null;
  return FOLDER_ICONS.find(i => i.src === src) || null;
}
